import { render, staticRenderFns } from "./SPUSignup.vue?vue&type=template&id=4db4b1b0&scoped=true"
import script from "./SPUSignup.vue?vue&type=script&lang=ts"
export * from "./SPUSignup.vue?vue&type=script&lang=ts"
import style0 from "./SPUSignup.vue?vue&type=style&index=0&id=4db4b1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4b1b0",
  null
  
)

export default component.exports